<template>
    <div class="wrapper">

		<!-- toast -->
		<div class="toast-wrap">
            <span class="toast-msg">
			</span>
         </div>

		 <!-- 弹框 -->
		<div id="confirmationOverlay" class="overlay" :style="{display:showTip?'block':'none'}">
			<div class="dialog">
				<div class="dialog-title">提示</div>
				<div class="dialog-txt">{{ tipMsg }}</div>
				<div class="buttons">
					<div class="button1" @click="cancelAction()">我知道了</div>
					<div class="button2" @click="confirmAction()">立即跳转</div>
				</div>
			</div>
			</div>

		<div class="bg-container">
			<div class="bg-cover"></div>
			<img class="bg" src="https://file.40017.cn/hubble/alliance/h5share-bg1.jpg" alt="">
			<div class="bg-title">开启您的旅行</div>
			<!-- <div class="bg-subtitle">开启您的旅行</div> -->
		</div>
	</div>
</template>
<script>
import axios from "axios";
import { getCookie } from "../util/tool.js";
import { API_PATHS } from "../util/cps/config";
const PLATFORM = {
	MP: 1,
	H5: 2
};
const API = {
	ShareInfo: API_PATHS.ShareInfo // 轨迹上传
};
export default {
	name: "list",
	components: {},
	data() {
		return {
			showTip: false,
			tipMsgNoAuth:
				"非常抱歉，由于分销员账号异常，该预订链接已被暂停，您可直接跳转官网进行预订！",
			tipMsgSysError: "系统异常链接无法正常访问，即将跳转官网",
			tipMsg: "",
			productId: this.$route.query.productId,
			target: this.$route.query.target,
			memberId: this.$route.query.memberId,
			platform: this.$route.query.platform,
			distributorId: this.$route.query.distributorId,
			refId: this.$route.query.refId,
			ofId: this.$route.query.ofId,
			productCategory: this.$route.query.productCategory?this.$route.query.productCategory:""
		};
	},
	async mounted() {
		// this.tipMsg = this.tipMsgNoAuth;
		// this.showTip = true;
		// return

		document.title = "产品分享";
		//1.初始化
		//platfrom ==== H5/小程序平台 1小程序，2H5
		if (this.$route.query.platform == PLATFORM.MP) {
			//需要重定向登录
			setTimeout(() => {
				this.redirectGetWxAndJump(false);
			}, 100);
		}

		if (this.$route.query.platform == PLATFORM.H5) {
			this.authH5();
		}

		setTimeout(() => {
			console.log("等2s=> this.$route.query", this.$route.query);
		}, 2000);
	},
	watch: {},
	/*
	
	  
	我知道了。和立即跳转按钮


	toast下就可以，然后直接跳转主站指定业务线
	。
	*/
	methods: {
		//没任何操作
		cancelAction(){
			this.showTip = false
		},
		confirmAction(){
			//根据不同平台跳转
			this.jumpDefault()
		},
		jumpDefault(){
			if (this.$route.query.platform == PLATFORM.MP) {
				let pathurl ="/page/home/index/index?tab=3"
				console.log("现在拦截后跳转的地址pathurl", pathurl)
				console.log("之前需要跳转的地址", `/${this.$route.query.target}`)
				//tab跳转是switchTab
				wx.miniProgram.reLaunch({
					url: pathurl,
					success: function() {
						console.log("success");
					},
					fail: function(err) {
						console.log(
							"跳转回小程序的页面fail",
							err
						);
					}
				});
			}
			if (this.$route.query.platform == PLATFORM.H5) {
				window.location.href= "https://m.ly.com/"
			}
		},
		authH5() {
			axios
				.post(
					API.ShareInfo,
					{
						platform: this.platform,
						distributorId: this.distributorId,
						refId: this.refId,
						ofId: this.ofId,
						targetUrl: this.target,
						productCategory: this.productCategory,
						productId: this.productId,
						cookie: ""
					},
					{
						timeout: 5000
					}
				)
				.then(
					response => {
						console.log("H5轨迹接口：response", response);
						let resdata = response.data;
						//重新请求
						if (resdata.code === 9999) {
							console.log("有问题，不给跳转");
							// alert("暂时无法访问该产品");
							this.tipMsg = this.tipMsgNoAuth;
							this.showTip = true;
						} else if (resdata.code === 0) {
							// H5新打开webview
							var ua = navigator.userAgent.toLowerCase();
							//微信浏览器
							if(ua.match(/MicroMessenger/i)=="micromessenger") {
								//ios的ua中无miniProgram，但都有MicroMessenger（表示是微信浏览器）
								wx.miniProgram.getEnv((res)=>{
									if (res.miniprogram) {
										//最终小程序包的H5必须要编码，不然参数会丢
										//1.主要是票务涉及到跳转
										let target = decodeURIComponent(this.$route.query.target)
										let pathurl = `/page/home/webview/webview?src=${encodeURIComponent(target)}`
										// let pathurl = `/page/home/webview/webview?src=${decodeURIComponent(this.$route.query.target)}`
										wx.miniProgram.redirectTo({
											url: pathurl,
											success: function() {
												console.log("success");
											},
											fail: function(err) {
												console.log(
													"跳转回小程序的页面fail",
													err
												);
											}
										});
										console.log("在小程序里")
									} else {
										window.location.href = this.$route.query.target;
										console.log("不在小程序里")
									}
								})
							}else{
								//其他浏览器
								window.location.href = this.$route.query.target;
								console.log("不在微信里")
							}
							return;
						} else {
							//其他异常，可以跳转，根据不同类型跳转不同的页面，目前酒店跳转酒店
							this.toast2(this.tipMsgSysError)
							setTimeout(()=>{
								this.jumpDefault()
							},2000)
						}
					},
					reject => {}
				)
				.catch(function(error) {
					this.errorHandle(error)
				});
		},
		//1.cookie中拿信息
		//2.接口请求，判断是否过期
		//3.过期继续进行重定向
		//延迟打印，有些console被延迟打印
		//reget是否重新请求重定向
		redirectGetWxAndJump(reget) {
			console.log("cookies================");
			//wxuser
			let wxuser = getCookie("WxUser");
			if (wxuser && !reget) {
				setTimeout(() => {
					console.log("等待2s打印：wxuser=====", wxuser);
				}, 2000);
				console.log(
					"小程序环境中：存在wxuser对象，进行1轨迹接口请求 2跳转小程序"
				);

				//#region 手动demo调试分享流程
				// let wxxuser = window.localStorage.getItem('wxuser')
				// if(wxxuser == 1) {
				// 	window.localStorage.setItem('wxuser',2)
				// }else{
				// 	window.localStorage.setItem('wxuser',1)
				// }
				// wxxuser = window.localStorage.getItem('wxuser')
				// if(wxxuser == 1) {
				// 	//已过期，重新请求
				// 	console.log("已过期，重新请求重定向")
				// 	this.redirectGetWxAndJump(true)
				// }
				// if(wxxuser == 2) {
				// 	//成功，直接跳转
				// 	//2进行跳转指定小程序地址
				// 	const pathurl = `/${this.$route.query.target}`
				// 	alert(pathurl)
				// 	console.log('pathurl', pathurl)
				// 	// alert("开发调试中")
				// 	//TODO 跳转到商品已下架了？为啥
				// 	wx.miniProgram.redirectTo({
				// 		url: pathurl,
				// 		success: function() {
				// 			console.log("success");
				// 		},
				// 		fail: function(err) {
				// 			console.log("跳转回小程序的页面fail",err);
				// 		},
				// 	});
				// }
				//#endregion

				//1接口请求
				axios
					.post(
						API.ShareInfo,
						{
							platform: this.platform,
							distributorId: this.distributorId,
							refId: this.refId,
							ofId: this.ofId,
							targetUrl: this.target,
							productCategory: this.productCategory,
							productId: this.productId,
							cookie: wxuser
						},
						{
							timeout: 5000
						}
					)
					.then(
						response => {
							console.log("MP轨迹接口：response", response);
							let resdata = response.data;
							//重新请求
							if (resdata.code === 1000) {
								//已过期，重新请求
								console.log("已过期，重新请求重定向");
								this.redirectGetWxAndJump(true);
							} else if (resdata.code === 9999) {
								this.tipMsg = this.tipMsgNoAuth;
								this.showTip = true;
								// console.log("有问题，不给跳转，进行提示后跳转");
							} else if (resdata.code === 0) {
								//成功，直接跳转
								//2进行跳转指定小程序地址
								const pathurl = `/${this.$route.query.target}`;
								console.log("pathurl", pathurl);
								//首页是不同步的跳转sdk，出行会跳首页
								if(pathurl.indexOf("page/home/index/index")!=-1) {
									console.log('首页跳转逻辑')
									// alert("跳转地址："+ pathurl)
									wx.miniProgram.reLaunch({
										url: pathurl,
										success: function() {
											console.log("success");
										},
										fail: function(err) {
											console.log(
												"跳转回小程序的页面fail",
												err
											);
										}
									});
								}else{
									wx.miniProgram.redirectTo({
										url: pathurl,
										success: function() {
											console.log("success");
										},
										fail: function(err) {
											console.log(
												"跳转回小程序的页面fail",
												err
											);
										}
									});
								}
							} else {
								//toast之后跳转
								this.toast2(this.tipMsgSysError)
								setTimeout(()=>{
									//国内酒店
									this.jumpDefault()
								},2000)
							}
						},
						reject => {}
					)
					.catch(function(error) {
						console.log(error);
						this.errorHandle(error)
					});
			} else {
				console.log("定向中=====");
				let ofId = this.$route.query.ofId;
				let productId = this.$route.query.productId;
				let distributorId = this.$route.query.distributorId;
				let refId = this.$route.query.refId;
				let platform = this.$route.query.platform;
				let target = this.$route.query.target;
				let productCategory = this.$route.query.productCategory?this.$route.query.productCategory:"";
				//一定要urlencode不然没法用了！！！！会被截掉&之后的内容的
				target = encodeURIComponent(target);
				let sharePath = `${location.origin}${
					location.pathname
				}#/cpsDetail?ofId=${ofId}&productId=${productId}&distributorId=${distributorId}&refId=${refId}&platform=${platform}&target=${target}&productCategory=${productCategory}`;
				console.log("sharePath", sharePath);
				//带参数的需要encodeurl
				let encodeurl = encodeURIComponent(sharePath);

				let hrefurl = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx3827070276e49e30&redirect_uri=https://wx.17u.cn/flight/getopenid.html?url=${encodeurl}&showwxpaytitle=1&response_type=code&scope=snsapi_base&state=123&connect_redirect=1#wechat_redirect`;
				console.log("encodeurl", encodeurl);
				window.location.href = hrefurl;
			}
		},
		//请求异常处理
		errorHandle(error){
			//其他接口异常，默认跳转
			if (error.response) {
				// 请求已发出，服务器用状态码响应
				console.log("请求已发出，服务器用状态码响应")
				console.error(error.response.data);
				console.error(error.response.status);
				console.error(error.response.headers);
			} else if (error.request) {
				// 请求未发出，可能是请求错误
				console.log("请求未发出，可能是请求错误")
				console.error(error.request);
			} else {
				console.log("错误发生在设置请求的其他地方")
				console.error('Error', error.message);
			}
			this.jumpDefault()
		},
		toast2(msg) {
			setTimeout(function() {
				document
					.getElementsByClassName("toast-wrap")[0]
					.getElementsByClassName("toast-msg")[0].innerHTML = msg;
				var toastTag = document.getElementsByClassName("toast-wrap")[0];
				toastTag.className = toastTag.className.replace(
					"toastAnimate",
					""
				);
				setTimeout(function() {
					toastTag.className = toastTag.className + " toastAnimate";
				}, 100);
			}, 500);
		}
	}
};
</script>
<style scoped>
.bg {
	width: 130px;
	margin: 0 auto;
}
.bg-title {
	font-size: 14px;
	margin-top: 14px;
	color: #666;
}
.bg-subtitle {
	font-size: 12px;
	color: #8b9186;
	font-weight: 600;
	margin-top: 2px;
}

.wrapper {
	width: 100vw;
	height: 100vh;
	background-color: #f7f8fa;
}
.bg-container {
	font-size: 20px;
	text-align: center;
	font-weight: 600;
}
.bg-cover {
	width: 100vw;
	height: 250px;
	background: linear-gradient(180deg, #e6dafe 0%, #f7f8fa 100%);
}

.overlay {
	display: none; /* 默认隐藏 */
	position: fixed; /* 固定定位 */
	z-index: 1; /* 位于顶层 */
	left: 0;
	top: 0;
	width: 100%; /* 宽度全屏 */
	height: 100%; /* 高度全屏 */
	overflow: auto; /* 超出内容可滚动 */
	background-color: rgb(0, 0, 0); /* 遮罩层颜色，可调整 */
	background-color: rgba(0, 0, 0, 0.4); /* 遮罩层半透明 */
}
.dialog {
	position: fixed;
	background-color: #fefefe;
	margin: auto;
	padding: 20px;
	border: 1px solid #888;
	width: 60%;
	height: 200px;
	left: 0;
	right: 0;
	top: 0;
	bottom: 0;
	border-radius: 10px;
	display: flex;
	flex-direction: column;
	justify-content: space-between;
}
.dialog-title {
	font-size: 18px;
	font-weight: bold;
	text-align: center;
	margin-bottom: 10px;
}
.dialog-txt {
	font-size: 14px;
}
.buttons {
	margin-top: 20px;
	display: flex;
	flex-direction: column;
	font-size: 15px;
	align-items: center;
}
.button1 {
	border: none;
	width: 95%;
	border: 1px solid #ccc;
	cursor: pointer;
	background-color: #fff;
	border-radius: 20px;
	height: 40px;
	margin-bottom: 10px;
	display: flex;
	align-items: center;
	justify-content: center;
	-webkit-tap-highlight-color: transparent;
}
.button2 {
	-webkit-tap-highlight-color: transparent;
	border: none;
	color: #fff;
	width: 95%;
	border: 1px solid #ff8324;
	cursor: pointer;
	background-color: #ff8324;
	border-radius: 20px;
	height: 40px;
	display: flex;
	align-items: center;
	justify-content: center;
}

.toast-wrap {
	opacity: 0;
	position: fixed;
	/* background-color: #fefefe; */
	margin: auto;
	padding: 20px;
	width: 60%;
	height: 100px;
	left: 0;
	right: 0;
	top: 0;
	bottom: 0;
	border-radius: 10px;
	display: flex;
	flex-direction: column;
	justify-content: space-between;
}
.toast-msg {
	font-size: 16px;
	background-color: rgba(0, 0, 0, 0.7);
	padding: 2px 5px;
	border-radius: 5px;
	padding: 10px;
	color: #fff;
	text-align: center;
}
.toastAnimate {
	animation: toastKF 2s;
}
@keyframes toastKF {
	0% {
		opacity: 0;
	}
	25% {
		opacity: 1;
		z-index: 9999;
	}
	50% {
		opacity: 1;
		z-index: 9999;
	}
	75% {
		opacity: 1;
		z-index: 9999;
	}
	100% {
		opacity: 0;
		z-index: 0;
	}
}
</style>



// WEBPACK FOOTER //
// src/page/cpsDetail.vue